import {
    ADD_ERROR,
    ADD_LOADING,
    ADD_SUCCESS,
    DELETE_ERROR,
    DELETE_LOADING,
    DELETE_SUCCESS,
    UPDATE_ERROR,
    UPDATE_LOADING,
    UPDATE_SUCCESS,
    VIEW_ERROR,
    VIEW_LOADING,
    VIEW_SUCCESS,
} from "./actions";
const { combineReducers } = require("redux");

const initialState = {
    loading: false,
    success: false,
    error: false,
    payload: null,
};

const view = (state = initialState, action) => {
    switch (action.type) {
        case VIEW_LOADING:
            return {
                ...initialState,
                loading: action.loading,
            };
        case VIEW_SUCCESS:
            return {
                ...initialState,
                success: action.success,
                payload: action.payload,
            };
        case VIEW_ERROR:
            return {
                ...initialState,
                error: action.error,
            };
        default:
            return state;
    }
};

const add = (state = initialState, action) => {
    switch (action.type) {
        case ADD_LOADING:
            return {
                ...initialState,
                loading: action.loading,
            };
        case ADD_SUCCESS:
            return {
                ...initialState,
                success: action.success,
                payload: action.payload,
            };
        case ADD_ERROR:
            return {
                ...initialState,
                error: action.error,
            };
        case "MASTER_KODE_TRAYEK_ADD_RESET":
            return initialState;
        default:
            return state;
    }
};

const update = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_LOADING:
            return {
                ...initialState,
                loading: action.loading,
            };
        case UPDATE_SUCCESS:
            return {
                ...initialState,
                success: action.success,
                payload: action.payload,
            };
        case UPDATE_ERROR:
            return {
                ...initialState,
                error: action.error,
            };
        case "MASTER_KODE_TRAYEK_UPDATE_RESET":
            return initialState;
        default:
            return state;
    }
};

const deleteData = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_LOADING:
            return {
                ...initialState,
                loading: action.loading,
            };
        case DELETE_SUCCESS:
            return {
                ...initialState,
                success: action.success,
                payload: action.payload,
            };
        case DELETE_ERROR:
            return {
                ...initialState,
                error: action.error,
            };
        case "MASTER_KODE_TRAYEK_DELETE_RESET":
            return initialState;
        default:
            return state;
    }
};

const masterKodeTrayekReducers = combineReducers({
    view,
    add,
    update,
    delete: deleteData,
});

export default masterKodeTrayekReducers;
